import React from "react";
import nextId from "react-id-generator";
import { Images } from "../../../Assets/0a-exporter";
import CommonFooter from "../CommonFooter/CommonFooter";
import ReactPlayer from "react-player";
import "./institution-landing.style.scss";
import { Link } from "react-router-dom";
import { getAllTestimonials } from "../../../APIs/GetAPIs";
export default function InstitutionLanding({ initial }) {
  const [testimonials, setTestimonials] = React.useState("candidate");
  const [commentList, setCommentList] = React.useState({
    institute: [],
    candidate: [],
  });
  const [selectedComment, setSelectedComment] = React.useState(
  );
  const [selectedJob, setSelectedJob] = React.useState({
    belongsTo: 1,
    cards: [],
  });

  const handlePreviousButton = () => {
    if (!selectedComment.num) return;
    setSelectedComment(commentList[testimonials][selectedComment.num - 1]);
  };

  const handleNextButton = () => {
    if (selectedComment.num + 1 === commentList[testimonials].length) return;
    setSelectedComment(commentList[testimonials][selectedComment.num + 1]);
  };

  const setUpCommentList = async () => {
    let res = await getAllTestimonials();
    if (res.data.statusCode === 200) {
      let temp = { institute: [], candidate: [] };
      let numOne = 0;
      let numTwo = 0;
      res.data.data.map((obj) => {
        if (obj.testimonial_type === "institute") {
          temp = {
            ...temp,
            institute: [...temp.institute, { ...obj, num: numOne }],
          };
          numOne = numOne + 1;
        } else {
          temp = {
            ...temp,
            candidate: [...temp.candidate, { ...obj, num: numTwo }],
          };
          numTwo = numTwo + 1;
        }
      });
      if (temp.candidate.length) {
        setSelectedComment(temp.candidate[0]);
      } else {
        setSelectedComment(temp.institute[0]);
      }
      setCommentList({ ...temp });
    } else {
    }
  };
  const returnClassName = (obj) => {
    if (obj.belongsTo < selectedJob.belongsTo) {
      return "carousal-left";
    } else if (obj.belongsTo > selectedJob.belongsTo) {
      return "carousal-right";
    } else {
      return "carousal-middle";
    }
  };
  const returnCommentClassName = (obj) => {
    if (obj.num < selectedComment.num) {
      return "comment-left";
    } else if (obj.num > selectedComment.num) {
      return "comment-right";
    } else {
      return "comment-middle";
    }
  };

  React.useEffect(() => {
    setUpCommentList();
  }, []);
  React.useEffect(() => {
    window.scroll({ top: 0 });

    initial();
  }, []);
  return (
    <div className="institution-landing-main">
      <section
        style={{ backgroundImage: `url(${Images.bgImage})` }}
        className="ilm-first"
      >
        <div className="ilmf-left">
          <p>It’s simple & smart</p>
          <h1>Hiring is more relaxed with AcadsHR</h1>
          <button>Post a Job</button>
          <ul>
            <li>Secured payment methods</li>
            <li>100% privacy to your account</li>
            <li>Complete personalized assistance </li>
          </ul>
        </div>
        <div className="ilmf-right">
          <form className="ilmfr-form" onSubmit={(e) => e.preventDefault()}>
            <h5>Get in touch</h5>
            <div className="input-wrapper">
              <input placeholder="Full Name" />
            </div>
            <div className="input-wrapper">
              <input placeholder="Mobile number" />
            </div>
            <div className="input-wrapper">
              <input placeholder="Institution name" />
            </div>
            <div className="input-wrapper">
              <input placeholder="Email ID" />
            </div>
            <div className="input-wrapper">
              <input placeholder="City" />
            </div>
            <button>Submit Inquiry</button>
          </form>
        </div>
      </section>
      <section className="ilm-services">
        <img className="blue-dot-left" src={Images.blueDotsTopLeft} />
        <div className="ilm-services-title">
          <h4>
            <span> Plans</span> and Pricing
          </h4>
          <p>
            ACADSHR is one of the largest independent job board, Register your
            CV to start applying today.{" "}
          </p>
          <div className="ilm-plan-tab">
            {servicesMain.map((obj) => (
              <div>
                <img src={obj.icon} />
                <span>{obj.name}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="ilm-job-post">
          <div className="ilmjp-header">
            <img src={Images.jobPostLogo} alt="jp" />
          </div>
          <div className="ilmjp-plans-wrapper">
            {plans.map((obj) => (
              <div className="plans-card">
                <div className="plans-card-upper">
                  <img src={obj.icon} />
                  <div>
                    <h5>{obj.name}</h5>
                    <p>
                      <span>{obj.price}</span>/monthly
                    </p>
                  </div>
                </div>
                <ul>
                  <p>Feature of the {obj.name}</p>
                  {obj.feature.map((x) => (
                    <li>
                      <img src={Images.checkedLogoNew} />
                      {x.text}
                    </li>
                  ))}
                </ul>
                <button>Get Started</button>
                <p className="last-text">
                  Subscribe now & get {obj.discount}% off
                </p>
              </div>
            ))}
          </div>
          <div className="ilmjp-compliments">
            <img src={Images.blueDotsBottomRight} className="blue-dots-right" />
            <h5 className="ilmjp-title">Compliments provided with plans</h5>
            <div className="ilmjpc-wrapper">
              {complimentList.map((obj) => (
                <div key={obj.keyId} className="jp-compliment-card">
                  <img src={obj.icon} />
                  <h5>{obj.title}</h5>
                  <p>{obj.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="ilm-virtual-hr">
          <div className="virtual-hr-row">
            <div className="virtual-hr-row-left">
              <ReactPlayer
                width="100%"
                height="100%"
                play={true}
                url="https://www.youtube.com/watch?v=1TH6euYCm3o"
              />
            </div>
            <div className="virtual-hr-row-right">
              <div className="v-hr-r-r-upper">
                <img src={Images.virtualHR} />
                <p>
                  We will manage the entire HR processes for your institution
                  from Recruitment to the exit formalities of the new joinees.
                  Charges shall be based on the headcount and the services
                  offered. We will be your HR Partner and manage the entire HR
                  processes virtually.
                </p>
              </div>
              <div className="v-hr-r-r-lower">
                <h5>Plan details</h5>
                <p>Price based on head count</p>
                <div className="plan-details">
                  <span>Features of the Plan</span>
                  <div>
                    <p>
                      <img src={Images.checkedLogoNew} />
                      Whole HR process will be covered{" "}
                    </p>
                    <button>Get in touch</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="virtual-hr-compliments">
            <h5 className="vhc-title">Features provided with plan</h5>
            <div className="vhc-wrapper">
              {virtualHrCompliment.map((obj) => (
                <div>
                  <img src={obj.icon} />
                  <h5>{obj.title}</h5>
                  <p>{obj.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>{" "}
        <div className="ilm-smart-match">
          <div className="smart-match-row">
            <div className="smart-match-row-right">
              <div className="sm-r-r-upper">
                <img src={Images.smartMatch} />
                <p>
                  We ensure to the get the right talent as per the requirement
                  including any confidential positions. Charges will be 8.33% of
                  the annual CTC of the offered candidate.
                </p>
              </div>
              <div className="sm-r-r-lower">
                <h5>Plan details</h5>
                <p>Charges 8.33% of the annual CTC per person</p>
                <div className="plan-details">
                  <span>Features of the Plan</span>
                  <div>
                    <p>
                      <img src={Images.checkedLogoNew} />
                      Whole HR process will be covered{" "}
                    </p>
                    <button>Get in touch</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="smart-match-row-left">
              <ReactPlayer
                width="100%"
                height="100%"
                play={true}
                url="https://www.youtube.com/watch?v=qBbK9jD0wBo"
              />
            </div>
          </div>
          <div className="smart-match-compliments">
            <h5 className="smc-title">Features provided with plan</h5>
            <div className="smc-wrapper">
              {superMatchCompliments.map((obj) => (
                <div>
                  <img src={obj.icon} />
                  <h5>{obj.title}</h5>
                  <p>{obj.text}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="o-l-s-lower">
            <div>
              <h6>
                looking for opportunity to teach students & inspire them ?
              </h6>
              <p>To apply for job visit subpage for employees</p>
            </div>
            <Link onClick={() => window.scroll({ top: 0 })} to="/candidate">
              Apply For job
            </Link>
          </div>
        </div>
      </section>

      
      <section className="other-logo-section">
        <div className="o-l-s-upper">
          <div className="o-l-s-left">
            <div className="ols-overlay-top" />
            <div className="ols-overlay-bottom" />
            <div className="clients-wrapper">
              {clients.map((obj) => (
                <div key={obj.keyId}>
                  <img src={obj.img} />
                </div>
              ))}
            </div>
          </div>
          <div className="o-l-s-right">
            <h4>
              Each day, <span>1000+</span> new applicants are being added to our
              teacher talent pool.
            </h4>
            <p>
              We connect academicians with academies using our Tech platform for
              educational institutions and EdTech companies that are looking for
              academic talent.
            </p>
            <Link to="/login">Get Started</Link>
            {/* <img src={Images.mainLogo} /> */}
          </div>
        </div>
        <div className="o-l-s-lower">
          <div>
            <h6>
              Do you want teachers and mentors who can help your students grow?
            </h6>
            <p>Post a job now </p>
          </div>
          <Link to="/institution">Post a Job</Link>
        </div>
      </section>
      <section className="success-stories-wrapper">
        <div className="success-stories-row">
          <div className="ssr-left">
            <h2>
              Hear what <span>Academies and Academicians</span> have to say.
            </h2>
            <div>
              {/* <h5>Hear what Academies and Academicians have to say.</h5> */}
              <p>
                We are proud of what we've done to help institutions and
                candidates find the right talent and the right career. Check out
                how AcadsHR helped the dream job become a reality.
              </p>

              <h5>Rukmini</h5>
              <h6>Indus Public School</h6>
            </div>
          </div>
          <div className="ssr-right">
            <ReactPlayer
              width="100%"
              height="100%"
              play={true}
              url="https://www.youtube.com/watch?v=H55anFVVLho"
            />
          </div>
        </div>
      </section>
      <section className="testimonials-wrapper">
        <h3>
          Our <span>Testimonials</span>
        </h3>
        <div className="comment-switch">
          <div className={testimonials === "institute" ? "right-most" : ""} />
          {[
            { keyId: nextId(), id: "candidate", name: "From Candidates" },
            { keyId: nextId(), id: "institute", name: "From Institutes" },
          ].map((x) => (
            <h6
              className={x.id === testimonials ? "selected-switch" : ""}
              key={x.keyId}
              onClick={() => {
                setTestimonials(x.id);
                setSelectedComment(commentList[x.id][0]);
              }}
            >
              {x.name}
            </h6>
          ))}
        </div>

        <div className="comment-row">
          <div className="comment-wrapper">
            <img className="comma" src={Images.commas} />
            <img className="comma-inverted" src={Images.commasInverted} />

            <button
              onClick={() => handlePreviousButton()}
              className="previous-button"
            >
              <img src="https://img.icons8.com/fluency-systems-regular/48/000000/less-than.png" />
            </button>
            <button onClick={() => handleNextButton()} className="next-button">
              <img src="https://img.icons8.com/fluency-systems-regular/48/ffffff/more-than.png" />
            </button>
            <div className="comment-wrapper-second">
              {commentList[testimonials].map((obj) => (
                <div
                  key={obj.keyId}
                  className={`comment-card ${returnCommentClassName(obj)}`}
                >
                  <div>
                    {" "}
                    <p>
                      {obj.testimonial}
                      {obj.testimonial}
                    </p>
                  </div>

                  <h6>{obj.name}</h6>
                  <span>{obj.designation}</span>
                </div>
              ))}
            </div>
            <div className="comments-button">
              {commentList[testimonials].map((x) => (
                <button
                  className={
                    selectedComment._id === x._id ? "selected-button" : ""
                  }
                  onClick={() => setSelectedComment(x)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
      <CommonFooter />
    </div>
  );
}
const servicesMain = [
  { keyId: nextId(), name: "Job post", icon: Images.docBag },
  { keyId: nextId(), name: "Virtual HR", icon: Images.manLogo },
  { keyId: nextId(), name: "Smart match", icon: Images.darkLogo },
];

const plans = [
  {
    keyId: nextId(),
    name: "Lite Plan",
    price: "₹2,999",
    icon: Images.greenBox,
    feature: [
      { keyId: nextId(), text: "1 job post" },
      { keyId: nextId(), text: "Validity 30 Days" },
    ],
    discount: 5,
  },
  {
    keyId: nextId(),
    name: "Standard Plan",
    price: "₹27,999",
    icon: Images.orangeBox,
    feature: [
      { keyId: nextId(), text: "1 job post" },
      { keyId: nextId(), text: "Validity 30 Days" },
    ],
    discount: 10,
  },
  {
    keyId: nextId(),
    name: "Extended Plan",
    price: "₹16,999",
    icon: Images.blueBox,
    feature: [
      { keyId: nextId(), text: "1 job post" },
      { keyId: nextId(), text: "Validity 30 Days" },
    ],
    discount: 15,
  },
];
const complimentList = [
  {
    keyId: nextId(),
    icon: Images.resumeZoom,
    title: "Talent Acquisition",
    text: "helps you recruit the best talent to your institution.",
  },
  {
    keyId: nextId(),
    icon: Images.hiredLogo,
    title: "Induction / On-boarding",
    text: "creates best experience of new hires' on first day.",
  },
  {
    keyId: nextId(),
    icon: Images.infoLogo,
    title: "Employee Handbook",
    text: "provides easy access to all policies & benefits.",
  },
];
const virtualHrCompliment = [
  {
    keyId: nextId(),
    title: "Talent Acquisition",
    icon: Images.resumeZoom,
    text: "helps you recruit the best talent to your institution.",
  },
  {
    keyId: nextId(),
    title: "Induction / On-boarding",
    icon: Images.hiredLogo,
    text: "creates best experience of new hires' on first day.",
  },
  {
    keyId: nextId(),
    title: "Employee Handbook",
    icon: Images.infoLogo,
    text: "creates best experience of new hires' on first day.",
  },
  {
    keyId: nextId(),
    title: "Payroll Processing & Statutory Compliance",
    icon: Images.moneyEnvelope,
    text: "ensures on-time accurate salary processing with 100%",
  },
  {
    keyId: nextId(),
    title: "Performance Management",
    icon: Images.stocks,
    text: "framework to enable high performance culture.",
  },
  {
    keyId: nextId(),
    title: "Rewards & Recognition",
    icon: Images.goldMedal,
    text: "framework to identify and reward best teachers.",
  },
  {
    keyId: nextId(),
    title: "Customized HR Solution",
    icon: Images.zoomPeople,
    text: "to meet all your needs like policy drafting, letters, Emails...etc.",
  },
  {
    keyId: nextId(),
    title: "Teacher 360",
    icon: Images.lady,
    text: "to meet all your needs like policy drafting, letters, Emails...etc",
  },
];
const superMatchCompliments = [
  {
    keyId: nextId(),
    title: "Manpower Requisition",
    icon: Images.manWithCV,
    text: "helps you recruit the best talent to your institution",
  },
  {
    keyId: nextId(),
    title: "Sourcing Screening",
    icon: Images.resumeZoom,
    text: "creates best experience of new hires' on first day",
  },
  {
    keyId: nextId(),
    title: "Ready to Hire successfully.",
    icon: Images.hiredLogo,
    text: "creates best experience of new hires' on first day",
  },
];


const clients = [
  { keyId: nextId(), img: Images.clientOne },
  { keyId: nextId(), img: Images.clientTwo },
  { keyId: nextId(), img: Images.clientThree },
  { keyId: nextId(), img: Images.clientFour },
  { keyId: nextId(), img: Images.clientFive },
  { keyId: nextId(), img: Images.clientSix },
  { keyId: nextId(), img: Images.clientSeven },
  { keyId: nextId(), img: Images.clientEight },
  { keyId: nextId(), img: Images.clientNine },
  { keyId: nextId(), img: Images.client10 },
  { keyId: nextId(), img: Images.client11 },
  { keyId: nextId(), img: Images.client12 },
  { keyId: nextId(), img: Images.client13 },
  { keyId: nextId(), img: Images.client14 },
  { keyId: nextId(), img: Images.client15 },
  { keyId: nextId(), img: Images.client16 },
  { keyId: nextId(), img: Images.client17 },
  { keyId: nextId(), img: Images.client18 },
  { keyId: nextId(), img: Images.client19 },
  { keyId: nextId(), img: Images.client20 },
  { keyId: nextId(), img: Images.client21 },
  { keyId: nextId(), img: Images.client22 },
  { keyId: nextId(), img: Images.client23 },
  { keyId: nextId(), img: Images.client24 },
  { keyId: nextId(), img: Images.client25 },
  { keyId: nextId(), img: Images.client26 },
  { keyId: nextId(), img: Images.client27 },
  { keyId: nextId(), img: Images.client28 },
  { keyId: nextId(), img: Images.client29 },
  { keyId: nextId(), img: Images.client30 },
  { keyId: nextId(), img: Images.client31 },
  { keyId: nextId(), img: Images.client32 },
  { keyId: nextId(), img: Images.client33 },
  // { keyId: nextId(), img: Images.client34 },
  { keyId: nextId(), img: Images.client35 },
  { keyId: nextId(), img: Images.client36 },
  { keyId: nextId(), img: Images.client38 },
  { keyId: nextId(), img: Images.client39 },
  { keyId: nextId(), img: Images.client40 },
  { keyId: nextId(), img: Images.client41 },
  { keyId: nextId(), img: Images.client42 },
  { keyId: nextId(), img: Images.client43 },
  { keyId: nextId(), img: Images.client44 },
  { keyId: nextId(), img: Images.client45 },
  { keyId: nextId(), img: Images.client46 },
  { keyId: nextId(), img: Images.client47 },
  { keyId: nextId(), img: Images.client48 },
  { keyId: nextId(), img: Images.client49 },
  { keyId: nextId(), img: Images.client50 },

  { keyId: nextId(), img: Images.client51 },
];
